// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__pwjBG","info":"Alert_info__++spq","success":"Alert_success__u5UJ3","warning":"Alert_warning__QKqZn","danger":"Alert_danger__DVU09","pink":"Alert_pink__9Yg8T"};